@if (isCS && (debugMode$ | async)) {
  <div class="leading-relaxed">
    @if (borderTop()) {
      <hr class="my-3 border-gray-200" />
    }

    @if (label()) {
      <strong class="mr-1">{{ label() }}:</strong>
    }

    @if (value()) {
      <span
        uiCopyToClipboard
        [copyContent]="value()"
        class="inline-flex items-center gap-1 bg-error-600 text-white px-1 py-0.5 rounded hover:opacity-50">
        {{ value() }}
        <ui-icon icon="griddy-copy" [size]="16" />
      </span>
    }

    <span>&nbsp;</span>

    @if (computedLink() && linkLabel()) {
      <span>
        <a
          [href]="computedLink()"
          class="bg-error-600 text-white px-1 py-0.5 cursor-pointer rounded hover:opacity-50"
          target="_blank"
          matTooltip="This only ever shows for internal CS logins - click to follow the link">
          {{ linkLabel() }}
        </a>
      </span>
    }

    @if (borderBottom()) {
      <hr class="my-3 border-gray-200" />
    }
  </div>
}
